import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";

const initialState = {
  isBusy: false,
  busyMessage: "Please wait...",
};

export const GlobalActivityIndicatorSlice = createSlice({
  name: "globalActivityIndicator",
  initialState,
  reducers: {
    pleaseWait: (state, action) => {
      state.busyMessage = action.payload ?? initialState.busyMessage;
      state.isBusy = true;
    },
    finished: (state) => {
      state.isBusy = false;
      state.busyMessage = initialState.busyMessage;
    },
  },
});

export const selectIsBusy = (state: RootState) => {
  return state.globalActivityIndicator.isBusy;
};
export const selectBusyMessage = (state: RootState) => {
  return state.globalActivityIndicator.busyMessage;
};

export const { pleaseWait, finished } = GlobalActivityIndicatorSlice.actions;

export default GlobalActivityIndicatorSlice.reducer;
